import { useRef } from 'react';
import FormInput from 'components/form-input';
import { isCitimkt, config } from 'config';
import styles from './index.module.sass';
import iconSafe from 'assets/icon-safe.svg';

const BindCardForm = ({
  ccNumber,
  ccNumberErrorMessage,
  onCcNumberFocus,
  onCcNumberChange,
  ccExpireDate,
  ccExpireDateErrorMessage,
  onCcExpireDateFocus,
  onCcExpireDateChange,
  ccCVC,
  ccCVCErrorMessage,
  onCcCVCFocus,
  onCcCVCChange,
  merchantUid,
  transactionId,
  callbackUrl,
  hiddenFormButtonRef,
}) => {
  const ccExpireDateRef = useRef();
  const ccCVCRef = useRef();

  const CreditCardForm = () => {
    return (
      <form className={styles['hidden-form']} action={`${config.paymentUrl}/webview/credit_card`} method="post">
        <input type="hidden" name="pan" value={`${ccNumber.replace(/\s/g, '')}`} />
        <input type="hidden" name="expire_date" value={`${ccExpireDate.replace(/\//g, '')}`} />
        <input type="hidden" name="cvc" value={ccCVC} />
        <input type="hidden" name="merchant_uid" value={merchantUid} />
        <input type="hidden" name="transaction_id" value={transactionId} />
        <input type="hidden" name="custom_data[is_default]" value="yes" />
        <input type="hidden" name="frontend_callback_url" value={callbackUrl} />
        <button
          ref={hiddenFormButtonRef}
          id="iframe-button"
          type="submit"
          value="validate"
          style={{ display: 'none' }}
        />
      </form>
    );
  };

  const name = () => {
    if (!isCitimkt) return '';
    return '花旗';
  };

  return (
    <>
      <CreditCardForm />
      <div className={styles.title}>設定{name()}付款卡片</div>
      <div className={styles.desc}>
        加入{name()}付款卡片，立即開始享受路邊停車自動繳的便利。加油站、停車場也能馬上體驗麻吉付！
      </div>
      <div className={styles.form}>
        <FormInput
          inputMode="numeric"
          onFocus={onCcNumberFocus}
          placeholder={`${name()}信用卡/金融卡號碼`}
          value={ccNumber}
          maxLength={19}
          onTextChanged={value => {
            onCcNumberChange(value);
            if (value.length === 19) {
              ccExpireDateRef.current.focus();
            }
          }}
          errorMessage={ccNumberErrorMessage}
        />
        <div className={styles.row}>
          <div>
            <FormInput
              ref={ccExpireDateRef}
              inputMode="numeric"
              onFocus={onCcExpireDateFocus}
              placeholder="有效期 MM/YY"
              value={ccExpireDate}
              maxLength={5}
              onTextChanged={value => {
                onCcExpireDateChange(value);
                if (value.length === 5) {
                  ccCVCRef.current.focus();
                }
              }}
              errorMessage={ccExpireDateErrorMessage}
            />
          </div>
          <div>
            <FormInput
              inputMode="numeric"
              ref={ccCVCRef}
              onFocus={onCcCVCFocus}
              placeholder="背面 3 碼"
              value={ccCVC}
              maxLength={3}
              onTextChanged={onCcCVCChange}
              errorMessage={ccCVCErrorMessage}
            />
          </div>
        </div>
      </div>
      <div className={styles.hint}>新增卡片時將產生一筆台幣 1 元的過卡交易，不會實際請款。</div>
      <div className={styles.safe}>
        <img src={iconSafe} alt="icon-sage" />
        麻吉付採用 TLS 1.2 2048bit 加密技術，不會透露您的實際卡片資訊予第三方，致力保障用卡安全無虞。
      </div>
    </>
  );
};

export default BindCardForm;
